export default __webpack_public_path__ + "static/media/restaurant.1ee1f5d4.jpg";